import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import { extractHeaderText } from 'src/componentes/filtro/searchUtils';
import ModalFormCategoryBadge from './ModalFormCategoryBadge';

function getCategoryLabelText(label) {
  if (typeof label === 'string') {
    return label;
  }
  if (label == null) {
    return '';
  }
  return extractHeaderText(label) || '';
}

function ModalFormCategoryNavButton({ category, isActive, onClick }) {
  const labelRef = useRef(null);
  const [truncated, setTruncated] = useState(false);
  const labelText = getCategoryLabelText(category.label);
  const badge = category.badge;

  const checkTruncated = useCallback(() => {
    const el = labelRef.current;
    if (!el) {
      return;
    }
    setTruncated(el.scrollWidth > el.clientWidth);
  }, []);

  useLayoutEffect(() => {
    checkTruncated();
    window.addEventListener('resize', checkTruncated);
    return () => window.removeEventListener('resize', checkTruncated);
  }, [checkTruncated, category.label, badge?.text]);

  return (
    <button
      type="button"
      className={classnames('modalFormCategoryLayout__navButton', {
        'modalFormCategoryLayout__navButton--active': isActive,
        'modalFormCategoryLayout__navButton--withBadge': badge?.text != null,
      })}
      title={truncated && labelText ? labelText : undefined}
      onClick={onClick}
    >
      <span
        ref={labelRef}
        className="modalFormCategoryLayout__navButtonLabel"
      >
        {category.label}
      </span>
      <ModalFormCategoryBadge badge={badge} />
    </button>
  );
}

export default ModalFormCategoryNavButton;
